import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Button,
  IconButton,
} from '@mui/material';
import PropTypes from 'prop-types';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import AuthModal from './AuthModal';
import { useNotification } from './NotificationContext';
import { createProfile, resetPassword } from './api.js';
import { useHookState } from './NotificationApiHook';
import ResetPasswordModal from './ResetPasswordModal';
import { IMaskInput } from 'react-imask';
import PhoneMaskInput from './PhoneMaskInput';

const LoginModal = ({ open, onClose, setToken, handleLogin }) => {
  const [authOpen, setAuthOpen] = useState(false);
  const [resetPwdOpen, setResetPwdOpen] = useState(false);
  const [values, setValues] = useState({
    username: '+7', // телефон
    password: '',
  });
  const theme = useTheme();
  const { openNotification } = useNotification();
  const { notificationState } = useHookState();
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleClose = () => {
    setValues({
      username: '',
      password: '',
    });
    onClose();
  };

  const handleLoginClick = () => {
    const data = { username: values.username, password: values.password };
    handleLogin(data);
  };

  const handleAuthOpen = () => {
    setAuthOpen(true);
  };

  const handleAuthClose = () => {
    setAuthOpen(false);
  };

  const handleResetPwdOpen = () => {
    setResetPwdOpen(true);
  };

  const handleResetPwdClose = () => {
    setResetPwdOpen(false);
  };

  // Обработчик для регистрации нового профиля
  const handleRegister = async (name, password, smsCode) => {
    const token = sessionStorage.getItem('sms_token');
    const ok = createProfile(name, password, smsCode, token, notificationState);
    if (ok) {
      handleAuthClose();
    }
  };

  const handleResetPwd = async (password, smsCode) => {
    const token = sessionStorage.getItem('reset_token');
    const ok = resetPassword(password, smsCode, token, notificationState);
    if (ok) {
      handleResetPwdClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle sx={{ textAlign: 'center', marginBottom: '10px' }}>Вход</DialogTitle>
      <DialogContent>
        <Box mt={2}>
          <TextField
            label='Телефон'
            name='username'
            value={values.username}
            onChange={handleChange} // Обработчик изменения
            InputProps={{
              inputComponent: PhoneMaskInput,
            }}
            fullWidth
          />
        </Box>
        <Box mt={2}>
          <TextField
            type={showPassword ? 'text' : 'password'}
            label='Пароль'
            fullWidth
            name='password' // Добавил имя для поля пароля
            value={values.password} // Используем значение из состояния
            onChange={handleChange} // Используем общий обработчик
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={handleTogglePassword}
                  edge='end'
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />
        </Box>
      </DialogContent>
      <Button
        sx={{ textTransform: 'none' }}
        onClick={handleAuthOpen}
      >
        {' '}
        Нет аккаунта? Зарегистрироваться{' '}
      </Button>
      <Button
        sx={{ textTransform: 'none' }}
        onClick={handleResetPwdOpen}
      >
        {' '}
        Восстановить пароль{' '}
      </Button>
      <DialogActions sx={{ justifyContent: 'center', textAlign: 'center' }}>
        <Button onClick={handleClose}>Закрыть</Button>
        <Button
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderRadius: '0px',
            width: '115px',
          }}
          onClick={handleLoginClick}
        >
          Войти
        </Button>
      </DialogActions>
      <AuthModal
        open={authOpen}
        onClose={handleAuthClose}
        onRegister={handleRegister}
      />
      <ResetPasswordModal
        open={resetPwdOpen}
        onClose={handleResetPwdClose}
        onPwdChange={handleResetPwd}
      />
    </Dialog>
  );
};

export default LoginModal;
